import React, { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";

import ACTIONS from "../../../pages/DesignAssets/Design_Asset_Actions.json";
import MyErrorBoundary from "../../../utils/ErrorBoundary";
import useCBMouserOver from "../../../pages/CustomHooks/useCBMouserOver";
import UtilitySVG from "../SLD/UtilitySVG";
import PowerMeterSVG from "../SLD/PowerMeterSVG";
import CircuitBreakerSVG from "../SLD/CircuitBreakerSVG";


const Utility = () => {
  const {
    CBAssetList: [{ uiData, configData, powerMeterData, cbConfigData }],
    UserScope,
    assetDetailsDisplay,
    CBAssetListDispatch,
    assetDetailsReset,
    callSnackbar,
    selectedValuesHandler,
    assetConfigDataHandler,
    setAssetDetailsDisplay,
    pmConfigDataHandler,
    switchboardType,
    newSBCbConfigDataHandler,
    
  } = useContext(DesignAssetContext);
  const [mouseOverData, CBMouseHandler] = useCBMouserOver();
  const utilitySelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "assetUtilityDetailsBlock";
      const selectedAssetValue = "selectedAsset";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_SELECT,
        payload: {
          index: 0,
          assetDetailsDisplay,
          setAssetDetailsDisplay,
        },
      });
      selectedValuesHandler(0, selectedAssetValue, assetBlock);
      assetConfigDataHandler(0);
    } else {
      callSnackbar(
        "error",
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
  const utilityPMSelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      const assetBlock = "pmAssetDetailsBlockGrid";
      const selectedAssetValue = "selectedAssetPM";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_PM_SELECT,
        payload: {
          index: 0,
        },
      });
      selectedValuesHandler(0, selectedAssetValue, assetBlock);
      pmConfigDataHandler(0);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };
  const utilityCBSelectHandler = () => {
    assetDetailsReset();
    if (UserScope.access.saveSLD) {
      // const assetBlock = "cbAssetDetailsBlock";
      const assetBlock = "newSBCbAssetDetailsBlock";
      const selectedAssetValue = "selectedAssetCB";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_CB_SELECT,
        payload: {
          index: 0,
        },
      });
      selectedValuesHandler(0, selectedAssetValue, assetBlock);
      // cbConfigDataHandler(4);
      newSBCbConfigDataHandler(0);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  return (
    <MyErrorBoundary>
      <>
        {switchboardType === "NEW_SWITCHBOARD" ? (
          <svg className="pointer">
            <UtilitySVG
              x={uiData.xAxis}
              y="141"
              handler={utilitySelectHandler}
              configData={configData}
              uiData={uiData}
              index={0}
            />
            <PowerMeterSVG
              x="375"
              y="127.5"
              handler={utilityPMSelectHandler}
              powerMeterData={powerMeterData}
              uiData={uiData}
              index={0}
            />
            <CircuitBreakerSVG 
              id={"utility"}
              x ={"470.5"}
              y ={"270"}
              index ={0}
              cbRequiredSelection={true}
              utilityCBSelectHandler={utilityCBSelectHandler}
              CBMouseHandler={CBMouseHandler}
              uiData={uiData}
              mouseOverData={mouseOverData}
              name={cbConfigData?.name}
            />
           
          </svg>
        ) : (
          <svg className="pointer">
            <UtilitySVG
              x="100"
              y="41"
              handler={utilitySelectHandler}
              configData={configData}
              uiData={uiData}
               index={0}
            />
            <PowerMeterSVG
              x="105"
              y="33"
              handler={utilityPMSelectHandler}
              powerMeterData={powerMeterData}
              uiData={uiData}
              index={0}
            />

            <g id="CB1">
              <line
                x1="235.5"
                y1="278"
                x2="235.5"
                y2="168"
                id="Line-2"
                strokeWidth="3"
                strokeDasharray="4 8"
                strokeLinecap="round"
                stroke="var(--se-sld-circline)"
                // strokeLinejoin="round"
              ></line>
            </g>
          </svg>
        )}
    
      </>
    </MyErrorBoundary>
  );
};

export default Utility;
